import React from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@forgeglobal/design-framework';
import { useStyles } from '../style';

interface CellProps {
  onToggle: () => void;
  isExpanded: boolean;
  canExpand: boolean;
}

const ExpandCell = ({ onToggle, isExpanded, canExpand }: CellProps) => {
  const classes = useStyles({});
  if (!canExpand) return <div> </div>;

  return isExpanded ? (
    <ChevronUpIcon onClick={onToggle} />
  ) : (
    <ChevronDownIcon onClick={onToggle} />
  );
};

export default ExpandCell;
